import VideoContainer from './video-container';

export default {
  init: function (selector) {
    const videoContainers = document.querySelectorAll(selector);

    if (videoContainers && videoContainers.length) {
      [...videoContainers].map(item => {
        const videoContainer = new VideoContainer(item);
        videoContainer.init();
      });
    }
  }
};
